import { UserRole } from "components/User/constants";

export const AppRouteURI = Object.freeze({
  HOME: "/",
  SCENARIO: "/scenario",
  CENTRAL_ARIZONA: "/central_arizona",
  PUBLIC: "/public",
  VISUALIZATIONS: "/visualizations",
  MAP_VIZ: '/map',
  HONEYCOMB_VIZ: '/honeycomb',
  PUBLIC_MAP_VIZ: '/publicmap',
  PUBLIC_HONEYCOMB_VIZ: '/honeycomb',
  DOUGHNUT_VIZ: '/doughnut',
  AREA_VIZ: '/area',
  GUAGUE_VIZ: '/gauge',
  WATER_USER: "/water_user",
  WATER_USER_VIZ: "/water_user/:type",
  ARIZONA: "/arizona",
  LOGIN: "/login",
  LOGOUT: "/logout",
  REGISTER: "/register",
  VERIFY_EMAIL: "/verify_email",
  RESEND_VERIFICATION: '/resend_verification',
  RESET_PWD: "/reset_password",
  INVITATION: "/invitation",
  MEMBERS: "/members",
  SECURITY: "/security",
  SETTINGS: "/settings",
  FEATURE_SETTINGS: "/feature_settings",
  INVITES: "/invites",
});

export const AppRoutingRoles = Object.freeze({
  [AppRouteURI.HOME]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.SCENARIO]: {
    isProtected: true,
    checkRoles: [],
  },
  [AppRouteURI.CENTRAL_ARIZONA]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.WATER_USER]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.PUBLIC]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.VISUALIZATIONS]: {
    isProtected: true,
    checkRoles: [],
  },
  [AppRouteURI.ARIZONA]: {
    isProtected: false,
    checkRoles: [],
  },
  [AppRouteURI.MEMBERS]: {
    isProtected: true,
    checkRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  [AppRouteURI.INVITES]: {
    isProtected: true,
    checkRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  [AppRouteURI.SECURITY]: {
    isProtected: true,
    checkRoles: [UserRole.SUPERADMIN],
  },
  [AppRouteURI.SETTINGS]: {
    isProtected: true,
    checkRoles: [],
  },
  [AppRouteURI.FEATURE_SETTINGS]: {
    isProtected: true,
    checkRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  [AppRouteURI.LOGOUT]: {
    isProtected: false,
    checkRoles: [],
  },
});
